import React from "react";
import { Modal, Button } from "react-bootstrap";

const InvoiceDetailModal = ({ show, onHide, invoice }) => {
  if (!invoice) return null;

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Invoice Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Client Name :</strong> {invoice.id_client?.name || "N/A"}
        </p>
        <p>
          <strong>Month/Year :</strong> {invoice.month}/{invoice.year}
        </p>
        <p>
          <strong>Trips :</strong> {invoice.trips}
        </p>
        <p>
          <strong>Total KM :</strong> {invoice.totalKm}
        </p>
        <p>
          <strong>Payout :</strong> {invoice.payout}
        </p>
        <p>
          <strong>Cash Short:</strong> {invoice.cashSort}
        </p>
        <p>
          <strong>Fixed Vehicle Count :</strong> {invoice.fixedVehicleCount}
        </p>
        <p>
          <strong>Invoice Generated Amount:</strong> {invoice.invoiceGenerated}
        </p>
        <p>
          <strong>Actual Amount Received :</strong>{" "}
          {invoice.actualAmountReceived}
        </p>

        <p>
          <strong>Mail Sent :</strong> {invoice.misEmailSent ? "Yes" : "No"}
        </p>

        <p>
          <strong>Mail Sent Date:</strong>{" "}
          {formatDate(invoice.misEmailSentDate)}
        </p>

        <p>
          <strong>Payment Received :</strong>{" "}
          {invoice.paymentReceived ? "Yes" : "No"}
        </p>

        <p>
          <strong>Payment Received Date:</strong>{" "}
          {formatDate(invoice.paymentReceivedDate)}
        </p>
        <p>
          <strong>Commnets :</strong> {invoice.comments}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InvoiceDetailModal;
